import axios from 'axios';

export default {
	getScores() {
		return axios.get('/api/scores');
	},
};
